import { useQuery } from 'react-query';
import axios from 'axios';
import { ItemDto } from '../models/item';

// item 1480 LAW / item 1518 — every index endpoint defaults to a 100-row page, so the item
// catalog silently lost rows past the 100th (same trap that drifted the invoice KPIs). Ask
// for the whole index explicitly, like useInvoices' INDEX_PAGE; the API default is being
// raised to 2000 too, but this works against any API build.
export const ITEMS_INDEX_PAGE = 2000;

export const getItems = async (): Promise<ItemDto> => {
  const apiUrl = process.env.REACT_APP_BASIX_API || '';
  const { data } = await axios.get(`${apiUrl}item`, { params: { pageSize: ITEMS_INDEX_PAGE } });
  return data;
};

const useItems = () => useQuery('items', getItems);

export default useItems;
